import $ from 'jquery';

// const extractContent = (s) => {
//   const span = document.createElement('span');
//   span.innerHTML = s;
//   return span.textContent || span.innerText;
// };

if ($('.press_list--articles').length) {
  const name = 'chainflixofficial';

  $.getJSON(
    `https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@${name}`,
    ({ items }) => {
      console.log(items);

      const itemsHtml = items.slice(0, 3).reduce(
        (acc, { title, thumbnail, link, pubDate }) => `${acc}
        <div class="press_item press_item--articles">
          <a class="press_pic press_pic--articles" href="${link}" target="_blank">
            <img src="${thumbnail}" alt="${title}">
          </a>
          <div class="press_content press_content-atricles">
            <a class="press_title press_title--articles" href="${link}" target="_blank">${title}</a>
            <div class="press_footnote press_footnote--articles">
              <div class="press_date">${pubDate.split(' ')[0]}</div>
              <a class="button clear press_more" href="${link}" target="_blank">
                Read press
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <use fill="currentColor" href="/assets/img/icons.svg#arrow_down"></use>
                </svg>
                </a>
            </div>
          </div>
        </div>
      `,
        ''
      );

      $('.press_list--articles').html(itemsHtml);
    }
  );
}
